import type { AdminTenantStatus } from "@gb/admin-contracts";
import { cn } from "@/lib/utils";

const TONES: Record<AdminTenantStatus, string> = {
  active: "bg-ok-bg text-ok border-ok-border",
  provisioning: "bg-warn-bg text-warn border-warn-bg",
  suspended: "bg-danger-bg text-danger border-danger-bg",
};

export function TenantStatusPill({ status }: { status: AdminTenantStatus }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 font-display text-[0.62rem] font-semibold tracking-[0.08em] uppercase",
        TONES[status],
      )}
    >
      {status}
    </span>
  );
}
